import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'content-block',
    templateUrl: './content-block.component.html',
    standalone: false
})
export class ContentBlockComponent {
	@Input() isLoading: boolean = false;
	@Input() title: string = '';
	@Input() count: number = null;

	@Input() headerActions: TemplateRef<any>;
	@Input() classList: string;
	@Input() showHeader: boolean = true;
}
